import styled, { css } from "styled-components";
import { TEXT_SECONDARY, WHITE } from "@streeteasy/design-system/colors";
import Button from "@streeteasy/design-system/deprecated/actions/button";

import { smallScreen } from "src/shared/constants/screenSizes";

export const RecentlyViewedContainer = styled.div`
  margin: 0 auto;
  max-width: 1404px;
  padding: 0 48px 38px;
  position: relative;

  &:nth-child(3) {
    padding-top: 38px;
  }

  @media screen and (max-width: ${smallScreen}px) {
    padding-bottom: 14px;
    padding-left: 24px;
    padding-right: 24px;

    &:nth-child(3) {
      padding-top: 14px;
    }
  }

  .swiper {
    margin-left: 0;
    padding: 0 2px;
  }

  .swiper-slide {
    min-width: 312px;
    padding: 10px 0;
  }
`;

export const SliderWrapper = styled.div`
  display: flex;
  padding: 22px 0 0;
  position: relative;

  @media screen and (max-width: ${smallScreen - 1}px) {
    display: none;
  }

  .swiper-slide {
    margin-right: 16px;
    width: calc(50% - 16px / 2);

    @media screen and (min-width: ${1090}px) {
      width: calc(100% / 3 - 32px / 3);
    }

    @media screen and (min-width: 1416px) {
      width: calc(25% - 48px / 4);
    }
  }
`;

const baseNavigationArrow = css`
  color: ${TEXT_SECONDARY};
  font: 22px/25px FontAwesome;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
`;

const NavigationButton = styled.button`
  background: ${WHITE};
  border: none;
  border-radius: 50%;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.137228);
  font-size: 0;
  height: 52px;
  position: absolute;
  top: calc(50% - 26px);
  width: 52px;
  z-index: 1;

  &[disabled] {
    display: none;
  }

  &:before {
    ${baseNavigationArrow}
  }

  @media screen and (max-width: ${smallScreen - 1}px) {
    display: none;
  }
`;

export const ListingCardWrapper = styled.div`
  @media screen and (max-width: ${smallScreen}px) {
    margin-bottom: 24px;
    width: 100%;
  }
`;

export const NextButton = styled(NavigationButton)`
  right: -78px;

  @media screen and (max-width: 1505px) {
    right: 0;
    top: -35px;
  }

  &:before {
    content: "\f105";
    right: 21px;
  }
`;

export const PreviousButton = styled(NavigationButton)`
  left: -78px;

  @media screen and (max-width: 1505px) {
    left: auto;
    right: 76px;
    top: -35px;
  }

  &:before {
    content: "\f104";
    left: 21px;
  }
`;

export const MobileListings = styled.div`
  display: none;

  @media screen and (max-width: ${smallScreen - 1}px) {
    align-items: center;
    display: flex;
    flex-direction: column;
    padding: 24px 0;
  }
`;

export const SeeMoreButton = styled(Button)`
  display: ${props => (props.isVisible ? "block" : "none")};
`;
